import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  forwardRef,
  HostBinding,
  Inject,
  Optional,
  Renderer2,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';
import { MaterialModule } from '@lockton-apps/material';
import { ToggleListItemTitleDirective } from './toggle-list-item-title.directive';
import { ToggleListComponent } from './toggle-list.component';

@Component({
    selector: 'la-toggle-list-item',
    imports: [CommonModule, MaterialModule],
    templateUrl: './toggle-list-item.component.html',
    styleUrls: ['./toggle-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleListItemComponent extends CdkAccordionItem {
  @HostBinding('class.lui-toggle-list-item--open')
  get hostClassOpen(): boolean {
    return super.expanded;
  }

  @ContentChild(ToggleListItemTitleDirective)
  title!: ToggleListItemTitleDirective;

  constructor(
    @Optional()
    @Inject(forwardRef(() => ToggleListComponent))
    public override readonly accordion: ToggleListComponent,
    private readonly host: ElementRef,
    private readonly renderer: Renderer2,
    cdr: ChangeDetectorRef,
    dispatcher: UniqueSelectionDispatcher
  ) {
    super(accordion, cdr, dispatcher);
  }

  set visibility(visibility: 'hidden' | 'visible') {
    this.renderer.setStyle(
      this.host.nativeElement,
      'display',
      visibility === 'hidden' ? 'none' : 'block'
    );
  }
}
